import { IAction } from '@Root/types'

export const ExportationActionTypes = {
  GET_FOLLOWED_EXPORTATIONS: '@@exportation/GET_FOLLOWED_EXPORTATIONS',
  GET_FOLLOWED_EXPORTATIONS_SUCCESS: '@@exportation/GET_FOLLOWED_EXPORTATIONS_SUCCESS',
  ADD_FOLLOWED_EXPORTATION: '@@exportation/ADD_FOLLOWED_EXPORTATION',
  REMOVE_FOLLOWED_EXPORTATION: '@@exportation/REMOVE_FOLLOWED_EXPORTATION',
  CHANGE_EXPORTATION_SETTINGS: '@@exportation/CHANGE_EXPORTATION_SETTINGS',
  SET_EXPORTATION_SETTINGS: '@@exportation/SET_EXPORTATION_SETTINGS',
  SET_STYLES_SETTINGS: '@@exportation/SET_STYLES_SETTINGS',
}

export interface IExportation {
  readonly followedExportations: IFollowedExportation[]
  readonly followedExportationIds: number[]
  readonly exportationSettings: IExportationSettings
}

export interface IFollowedExportation {
  readonly id: number
  readonly attributes: IFollowedExportationAttributes
}

export interface IGetFollowedExportationsPayload {
  readonly exportationIds: number[]
}

export interface IFollowedExportationAttributes {
  readonly progress: number
  readonly projectVersionId?: string
  readonly subtitleId?: number
  readonly urls?: string[]
  readonly error?: boolean
  readonly projectTitle?: string
  readonly projectDuration?: number
}

export interface IAddFollowedExportationPayload {
  readonly exportationId: number
}

export interface IRemoveFollowedExportationPayload {
  readonly exportationId: number
}

export interface IGetFollowedExportationsSuccessPayload {
  readonly data: IFollowedExportation[]
}

export interface IEmptyProjectVersionExportationSettings {
  readonly scale: boolean
  readonly format: string
  readonly watermark: boolean
  readonly resolution: string
}

export interface IExportationSettings extends IEmptyProjectVersionExportationSettings {
  readonly burnInSubtitles: string
  readonly addDashesForSpeakers: boolean
  readonly includeItalicFormatting: boolean
  readonly addSpeakerNames: boolean
  readonly exportAudiosSeparately: boolean
  readonly exportSpeakersSeparately: boolean
  readonly [key: string]: string | boolean
}

export interface ISetExportationSettingsPayload {
  readonly exportation: IExportationSettings
}

export interface IChangeExportationSettingsPayload {
  readonly key: string
  readonly value: string | boolean
}

export type IGetFollowedExportationsSuccessResponseBody = IGetFollowedExportationsSuccessPayload

export type TExportationAction =
  IAction<IGetFollowedExportationsSuccessPayload> |
  IAction<IAddFollowedExportationPayload> |
  IAction<IRemoveFollowedExportationPayload> |
  IAction<ISetExportationSettingsPayload> |
  IAction<IChangeExportationSettingsPayload>
